import type { ColumnConfig } from '@/components/configure-columns-dialog';

// Default column configuration for the Asset History (Enquiry) screen
export const DEFAULT_ENQUIRY_COLUMNS: ColumnConfig[] = [
  // Default columns (visible by default)
  { id: 'auditNo', label: 'Audit No.', visible: true, order: 0, group: 'default' },
  { id: 'assetCode', label: 'Asset Code', visible: true, order: 1, group: 'default' },
  { id: 'description', label: 'Description', visible: true, order: 2, group: 'default' },
  { id: 'reference', label: 'Reference', visible: true, order: 3, group: 'default' },
  { id: 'date', label: 'Date', visible: true, order: 4, group: 'default' },
  { id: 'year', label: 'Year', visible: true, order: 5, group: 'default' },
  { id: 'period', label: 'Period', visible: true, order: 6, group: 'default' },
  { id: 'type', label: 'Type', visible: true, order: 7, group: 'default' },
  { id: 'startNBV', label: 'Start Net Book Value', visible: true, order: 8, group: 'default' },
  { id: 'movementValue', label: 'Movement Value', visible: true, order: 9, group: 'default' },
  { id: 'depreciationMovement', label: 'Depreciation Movement', visible: true, order: 10, group: 'default' },
  { id: 'endNBV', label: 'End Net Book Value', visible: true, order: 11, group: 'default' },
  { id: 'detail', label: 'Detail', visible: true, order: 12, group: 'default' },
  { id: 'targetYear', label: 'Target Year', visible: true, order: 13, group: 'default' },
  { id: 'targetPeriod', label: 'Target Period', visible: true, order: 14, group: 'default' },
  
  // Optional columns (hidden by default)
  { id: 'subLedger', label: 'Sub Ledger', visible: false, order: 15, group: 'optional' },
  { id: 'category', label: 'Category', visible: false, order: 16, group: 'optional' },
  { id: 'status', label: 'Status', visible: false, order: 17, group: 'optional' },
  { id: 'percentage', label: 'Percentage', visible: false, order: 18, group: 'optional' },
  { id: 'transferredTo', label: 'Transferred To', visible: false, order: 19, group: 'optional' },
  { id: 'transferredFrom', label: 'Transferred From', visible: false, order: 20, group: 'optional' },
  { id: 'project', label: 'Project', visible: false, order: 21, group: 'optional' },
  { id: 'costCentre', label: 'Cost Centre', visible: false, order: 22, group: 'optional' },
  { id: 'disposalReason', label: 'Disposal Reason', visible: false, order: 23, group: 'optional' },
  { id: 'user', label: 'User', visible: false, order: 24, group: 'optional' },
];

export const ENQUIRY_COLUMNS_STORAGE_KEY = 'asset-history-columns-config';
